import { IconButton, TextField, Tooltip } from '@mui/material';
import React from 'react';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import reusableInputStyles from '../InputStyles';
import { generateSql, getFields, getOptions, getWorkqueueFilterOptions } from './utils';
import { withField } from './withField';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { ErrorMessage } from './ErrorMessage';
import { getIn } from 'formik';

const SqlRuleBuilder = (props) => {
  const {
    name,
    value: current,
    setFieldValue,
    fields = [],
    isWorkqueueFilter = false,
    handleDelete,
    errors,
    touched,
    handleBlur,
    isReports = false,
    isDataManager = false,
  } = props;
  const classes = reusableInputStyles();
  const handleChange = (property, value) => {
    const copy = { ...current };
    copy[property] = value;
    if (property === 'field') {
      copy['condition'] = '';
      copy['value'] = '';
      copy['value1'] = '';
      copy['sqlValue'] = '';
    }
    if (property === 'condition') {
      if (current.field.fieldType.toLowerCase() === 'date') {
        copy['value'] = '';
        copy['valu1'] = '';
        copy['value1'] = '';
      } else {
        copy['value'] = '';
        copy['valu1'] = '';
        copy['value1'] = '';
      }
    }
    if (property === 'condition') {
      copy['type'] = { label: 'Value', value: 'value' };
    }
    generateSql(copy);
    setFieldValue(name, copy);
  };
  React.useEffect(() => {
    name && setFieldValue && setFieldValue(name, current);
  }, [name, current, setFieldValue]);

  const getError = (name) => getIn(touched, name) && getIn(errors, name);
  const showSqlOutput =
    (current?.condition &&
      (current?.condition?.value === 'isBlank' || current?.condition?.value === 'isNotBlank')) ||
    (current?.condition && current?.sqlValue && (current?.value || current?.value1));
  return (
    <div className="sql-builder-section mt-3 global-field-textfields">
      <div className="rulecode-section">
        <span>{current?.ruleCode}</span>
      </div>
      {/* Repository and Field */}
      {isReports ? (
        <>
          <div className="col-md-4 col-lg-2 form-group">
            <TextField
              fullWidth
              margin="dense"
              value={current?.field?.repositoryName}
              label="Repository"
            />
          </div>
          <div className="col-md-4 col-lg-2 form-group">
            <TextField fullWidth margin="dense" value={current?.field?.fieldName} label="Field" />
          </div>
        </>
      ) : (
        <div className="col-md-4 col-lg-3 form-group">
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            id="field"
            value={current?.field ? current?.field : ''}
            options={fields ? fields : []}
            size="small"
            autoHighlight
            name={`${name}.field`}
            getOptionLabel={(option) => {
              return option && option?.globalField && !isDataManager
                ? `${option?.repository} - ${option?.globalField}`
                : option && option?.fieldName && isDataManager
                  ? `${option?.repository} - ${option?.fieldName}`
                  : '';
            }}
            renderInput={(params) => (
              <GuiTextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                onBlur={handleBlur}
                margin="dense"
                label="Field"
                error={getError(`${name}.field`)}
                name={`${name}.field`}
                placeholder="Select field"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleChange('field', data);
            }}
          />
          <ErrorMessage
            render={(msg) => (
              <div className={msg ? `error-text rule-bulider-error` : ``}>{msg}</div>
            )}
            name={`sqlRules[${props.index}].field`}
          />
        </div>
      )}

      {/* Condition  */}
      {current?.field && (
        <div className="col-md-4 col-lg-2 form-group">
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            id="category"
            value={current?.condition}
            name={`${name}.condition`}
            options={
              isWorkqueueFilter
                ? getWorkqueueFilterOptions(current?.field?.fieldType?.toLowerCase())
                : getOptions(current?.field?.fieldType?.toLowerCase())
            }
            size="small"
            autoHighlight
            getOptionLabel={(option) => {
              return option && option?.value ? option.label : '';
            }}
            renderInput={(params) => (
              <GuiTextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={handleBlur}
                fullWidth
                margin="dense"
                label="Condition"
                name="condition"
                error={getError(`${name}.condition`)}
                placeholder="Select Condition"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleChange('condition', data);
            }}
          />
          <ErrorMessage
            render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
            name={`sqlRules[${props?.index}].condition`}
          />
        </div>
      )}

      {/* Value */}
      {current?.condition &&
      current?.condition?.value &&
      current?.condition?.value !== 'BETWEEN' &&
      current?.condition?.value !== 'NOT BETWEEN' ? (
          <div
            className={`${
            current?.condition.value === 'isBlank' || current?.condition.value === 'isNotBlank'
              ? 'col-lg-0'
              : 'col-md-4 col-lg-2'
          } form-group`}
          >
            {getFields({
              type: current?.field?.fieldType?.toLowerCase(),
              rule: current,
              name: `${name}.value`,
              name1: `${name}.value1`,
              error: getError(`${name}.value`),
              handleBlur,
              handleUpdateRule: handleChange,
            })}
          </div>
        ) : (
          current?.condition &&
        getFields({
          type: current?.field?.fieldType?.toLowerCase(),
          rule: current,
          name: `${name}.value`,
          name1: `${name}.value1`,
          error: getError(`${name}.value`),
          handleUpdateRule: handleChange,
        })
        )}
      {showSqlOutput && !isWorkqueueFilter && (
        <div className="output-field px-2 form-group">
          <div className="label-text  sql-output-label">SQL Output</div>
          <div className="sql-output-value" title={current?.sqlValue}>
            {current?.sqlValue}
          </div>
        </div>
      )}
      <div>
        <Tooltip title="Delete">
          <IconButton onClick={() => handleDelete(current)}>
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default withField(SqlRuleBuilder);
